import { createStyles, Title, Text, Button, Container, Group } from '@mantine/core';
import { useNavigate } from 'react-router-dom';

const useStyles = createStyles((theme) => ({
  root: {
    paddingTop: 80,
    paddingBottom: 80,
  },

  label: {
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 220,
    lineHeight: 1,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
    color: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],

    [theme.fn.smallerThan('sm')]: {
      fontSize: 120,
    },
  },

  title: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
    textAlign: 'center',
    fontWeight: 900,
    fontSize: 38,

    [theme.fn.smallerThan('sm')]: {
      fontSize: 32,
    },
  },

  description: {
    maxWidth: 500,
    margin: 'auto',
    marginTop: theme.spacing.xl,
    marginBottom: `calc(${theme.spacing.xl} * 1.5)`,
  },
}));

export function Page404() {
  const { classes } = useStyles();

  const navigate = useNavigate()

  return (
    <Container className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>Találtál egy titkos helyet.</Title>
      <Text color="dimmed" size="lg" align="center" className={classes.description}>
        Sajnos ez csak egy 404-es oldal.
        Lehet, hogy rosszul írtad be a címet, vagy az oldal már nem működik. Az is előfordulhat hogy átkerült egy másik URL-címre.
      </Text>
      <Group position="center">
        <Button variant="subtle" size="md" style={{marginTop: "25px"}} onClick={() => navigate("/home")}>
          Vissza a főoldalra
        </Button>
      </Group>
    </Container>
  );
}